<div *ngIf="isRowView">
    <div class="about-us">
        <div class="about-introduction">
            <h2>{{ 'introduction.introduction' | translate }}</h2>
        </div>
    </div>
    <div class="introduction-container">
        <div class="introduction-photos">
            <div class="intr">
                <div class="colleagues">
                    <div *ngFor="let colleague of colleagues; let i = index" class="colleague">
                        <div class="colleague-img">
                            <img [src]="colleague.imageUrl" />
                        </div>
                        <label>{{ colleague.name }}</label>
                        <label>{{ colleague.jobTitle }}</label>
                    </div>
                </div>
            </div>
        </div>

        <div class="introduction-text">
            <div class="introduction">
                <span>{{"introduction.introductionText" | translate}}</span>
                <span>{{"introduction.introductionText2" | translate}}</span>
                <span>{{"introduction.introductionText3" | translate}}</span>
            </div>
            <div class="contactinfo">
                <p>
                    {{"introduction.companyName" | translate }} <br />
                    {{"introduction.companyNumber" | translate }}<br />
                    {{this.address }}<br />
                    Postacím: {{this.address }}<br />
                    E-mail: {{this.email }} <br />
                    Telefon: {{this.cellphoneNumber }}<br />
                </p>
            </div>
        </div>
    </div>
</div>

<div *ngIf="!isRowView">
    <div class="introduction-container-column">
        <div class="about-us">
            <div class="about-introduction-container">
                <div class="about-introduction">
                    <h2>{{ 'introduction.introduction' | translate }}</h2>
                </div>
                <div class="about-introduction">
                    <h3>Gyors és könnyű időpontegyeztetés</h3>
                </div>
                <div class="about-introduction">
                    <span>Ha bármilyen kérdése van, vagy szeretne időpontot foglalni, vegye fel velünk a kapcsolatot! Mi
                        itt vagyunk, hogy
                        segítsünk Önnek a legjobb egészségügyi szolgáltatást biztosítani!</span><br />
                </div>
            </div>
        </div>
        <div class="address">
            <div class="ad">
                <div class="add">
                    <p>
                        Ha szeretne szakrendeléseink valamelyikére időpontot foglalni, megteheti azt online
                        felületünkön, de kereshet minket
                        e-mailben és telefonon is!
                    </p>
                    <p>
                        <span [ngStyle]="{'font-weight':'bold'}">Cím: </span>{{this.address}}(Lásd a lentebbi
                        térképet)<br />
                        <span [ngStyle]="{'font-weight':'bold'}">Telefonszám: </span> {{this.cellphoneNumber}}<br />
                        <span [ngStyle]="{'font-weight':'bold', 'color':'red','font-size':'18px'}">Vezetékes
                            telefonszámunk megváltozott:
                        </span>
                        {{this.landlinePhoneNumber}}<br />
                        <span [ngStyle]="{'font-weight':'bold'}">E-mail: </span>{{this.email}}<br />
                        <span>{{"introduction.call" | translate}}</span><br />
                    </p>
                    <p>
                        Ha először látogat el hozzánk, kérjük az alább található betegfelvételi adatlapot töltse ki és
                        hozza el nekünk,
                        ezzel meggyorsítva az adminisztratív teendőket és az Ön várakozási idejét is csökkentjük!
                    </p>
                </div>
                <div class="button-container">
                    <div class="buttons">
                        <a target="_blank" (click)="settingUpLinkToGoogleAnalytics()"
                            href="{{bookAppointmentsUrl}}"><button>IDŐPONTFOGLALÁS</button></a>
                        <a href="{{patientAdmissonFormUrl}}"><button>BETEGFELVÉTELI LAP</button></a>
                    </div>
                </div>
            </div>
            <div class="opening">
                <div class="span-container">
                    <div>
                        <h3>NYITVATARTÁS</h3>
                    </div>
                    <div class="text"><span>H: 8:00 - 20:00</span></div>
                    <div class="text"><span>K: 7:00 - 20:00</span></div>
                    <div class="text"><span>Sze: 8:00 - 20:00</span></div>
                    <div class="text"><span>Cs: 8:00 - 20:00</span></div>
                    <div class="text"><span>P: 7:00 - 20:00</span></div>
                    <div class="text"><span>Szo: 8:00 - 14:00</span></div>
                </div>
            </div>
        </div>
        <div class="introduction-photos-column">
            <div class="intr">
                <div class="colleagues">
                    <div *ngFor="let colleague of colleagues; let i = index" class="colleague">
                        <div class="colleague-img">
                            <img [src]="colleague.imageUrl" />
                        </div>
                        <label>{{ colleague.name }}</label>
                        <label>{{ colleague.jobTitle }}</label>
                    </div>
                </div>
            </div>
        </div>

        <div class="introduction-text-column">
            <div [ngStyle]="{'margin-bottom':'32px'}" class="introduction">
                <!--<p [ngStyle]="{'font-weight':'bold','text-align':'center'}">
                    Ha letölti a
                    <a [ngStyle]="{'margin-top':'16px','width':'90%'}" href="{{patientAdmissonFormUrl}}"
                        >{{"introduction.patientAdmissonForm" | translate}}</a
                    >{{"introduction.introductionText" | translate}}
                </p>-->
                <div class="transport-container">
                    <div class="map">
                        <pw-google-map [iframeSrc]="googleMapIframeSrc"></pw-google-map>
                    </div>
                    <div class="transport">
                        <p class="title" [ngStyle]="{'margin-bottom':'0'}">
                            <span
                                [ngStyle]="{'text-transform':'uppercase','font-weight':'bold'}">{{"introduction.kozlekedes"
                                | translate}}</span>
                        </p>
                        <p [ngStyle]="{'margin-bottom':'0'}"><b>Címünk: {{"introduction.address" | translate}}</b></p>
                        <p [ngStyle]="{'margin-bottom':'0'}">
                            <span> {{"introduction.metro" | translate}}</span><br />
                            <span> {{"introduction.metroText" | translate}}</span>
                        </p>
                        <p [ngStyle]="{'margin-bottom':'0'}">
                            <span> {{"introduction.tram" | translate}}</span><br />
                            <span> {{"introduction.tramText" | translate}}</span>
                        </p>
                        <p [ngStyle]="{'margin-bottom':'0'}">
                            <span> {{"introduction.troli" | translate}}</span><br />
                            <span> {{"introduction.troliText" | translate}}</span>
                        </p>
                        <p [ngStyle]="{'margin-bottom':'0'}">
                            <span> {{"introduction.bus" | translate}}</span><br />
                            <span> {{"introduction.busText" | translate}}</span>
                        </p>
                        <p [ngStyle]="{'margin-bottom':'0'}"><span> {{"introduction.car" | translate}}</span></p>
                        <p [ngStyle]="{'margin-bottom':'0'}"><span> {{"introduction.parking" | translate}}</span></p>
                        <p [ngStyle]="{'margin-bottom':'0'}"><span> {{"introduction.welcome" | translate}}</span></p>
                    </div>
                </div>
                <div class="permisson-form-container">
                    <div class="permission-form">
                        <div class="permisson">
                            <p [ngStyle]="{'font-size':'12px'}" [ngStyle]="{'font-weight':'bold'}">
                                {{"introduction.privacyPolicy" | translate}}
                            </p>
                        </div>
                        <div class="permisson">
                            <p [ngStyle]="{'font-size':'12px'}">{{"introduction.privacyPolicyText" | translate}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>